




























import { Component } from 'vue-property-decorator';
import RecurringPaymentsProductManagementMixin
  from '@/components/product/recurringPayments/recurringPaymentsProductManagement/RecurringPaymentsProductManagementMixin';
import { addClass, removeClass } from '@/utils/classUtils';
import {
  DeliveryCycleType,
  DiscountType,
  PutProductsRegularDeliveryRequest
} from 'supporter';
import ChangeInformationAndDiscountSettingForm from '@/components/product/recurringPayments/ChangeInformationAndDiscountSettingForm.vue';

interface SelectedProductInfo {
  mallNo: number;
  productNo: number;
  salePrice: number;
}

@Component({
  components: {
    ChangeInformationAndDiscountSettingForm,
  }
})
export default class RecurringPaymentsProductSettingChange extends RecurringPaymentsProductManagementMixin {
  private selectedProductsInfo: SelectedProductInfo[] = [];
  private deliveryCycles = '';
  private isUsedDiscount = false;
  private discountType: DiscountType = 'AMOUNT';
  private discountValue: string | null = null;
  private isInvalidDiscountValueFormat = false;

  private mounted() {
    addClass(document.body, 'popup_medium');
    this.selectedProductsInfo = JSON.parse (
      window.localStorage
        .getItem('selectedProductsInfo')
    )
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_medium');
  }

  // validation 사용 시 이 컴포넌트와 bind 필요
  private validations: { [key: string]: () => boolean } = {
    validateDeliveryCycles: function (): boolean {
      if (!this.deliveryCycles) {
        alert(this.getI18nOfThis('PLEASE_SELECT_DELIVERY_CYCLE'));
        return false;
      }
      return true;
    },
    confirmDiscountValueFormat: function(): boolean {
      const isNoInput = !this.discountValue;
      if (this.isInvalidDiscountValueFormat) {
        alert(this.getI18nOfThis('PLEASE_CHECK_INPUT'))
        if (isNoInput) {
          this.$refs['recurringPaymentsProductSettingChangeForm'].$refs['discountValue'].focus();
        }
      }
      return !this.isInvalidDiscountValueFormat
    },
    validateDiscountAmountOverflow: function (): boolean {
      if (this.discountType === 'PERCENT') return true;

      const isValid = this.selectedProductsInfo.every(productInfo => productInfo.salePrice >= this.discountValue);
      if (!isValid) {
        alert(this.getI18nOfThis('THERE_IS_PRODUCT_WITH_NEGATIVE_DISCOUNT_PRICE'));
      }
      return isValid;
    }
  }

  private validate(): boolean {
    return Object.values(this.validations).every(validation => validation.bind(this)())
  }

  private handleSaveBtnClick(): void {
    if (!confirm(this.getI18nOfThis('COMPLETE_REGISTRATION_CONFIRM_TEXT'))) return;
    if (!this.validate()) return;

    this.putProductsRegularDelivery().then(() => {
      alert(this.$t('ALERT_SAVE_SUCCESS'));
      window.close();
    }).catch(() => {
      return;
    })

  }
  private makePutProductsRegularDeliveryRequest(): PutProductsRegularDeliveryRequest {
    const deliveryCycleInfo = {
      isAll: this.deliveryCycles === 'ALL',
      deliveryCycles: this.deliveryCycles === 'ALL' ? [] : this.deliveryCycles.split(',') as DeliveryCycleType[],
    }
    const discount = this.isUsedDiscount ?
        {
          type: this.discountType,
          value: Number(this.discountValue),
        }
        : null;

    const data: PutProductsRegularDeliveryRequest['data'] = {
      products: this.selectedProductsInfo
          .map( productInfo => ({
            mallNo: productInfo.mallNo,
            productNo: productInfo.productNo
          })),
      deliveryCycleInfo: deliveryCycleInfo,
    }

    if (discount) {
      data['discount'] = discount;
    }

    return { data };
  }

  private async putProductsRegularDelivery(): Promise<void> {
    const request: PutProductsRegularDeliveryRequest = this.makePutProductsRegularDeliveryRequest();

    try {
      await this.$api.putProductsRegularDelivery(request);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  }

  private handleCancelBtnClick(): void {
    if (!confirm(this.getI18nOfThis('CANCEL_REGISTRATION_CONFIRM_TEXT'))) return;

    window.close();
  }
}

